import { faCheckCircle, faFloppyDisk, faPrint } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import React from 'react'

export default function ConfirmPrint({DoiNo, openDownload, setOpenDownload, loadingDownload, loadingDownloadDoi, downloadFile, downloadFileDoi}) {
    return (
        <Dialog
            open={openDownload}
            fullWidth
            maxWidth='md'
        >
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#4ab866', justifyContent: "center", paddingTop: '40px' }}>
                <FontAwesomeIcon style={{ fontSize: '4rem', }} icon={faCheckCircle} />
                <Typography sx={{ fontWeight: "700", fontSize: '1.5rem', color: '#4ab866', textAlign: "center", marginTop: "20px" }}>{`ทำรายการขายเรียบร้อย เลขที่ใบ Doi : ${DoiNo}`}</Typography>
            </DialogContent>
            <DialogActions sx={{ alignItems: "center", justifyContent: 'center' }}>
                <Button variant='outlined' sx={{ padding: '8px 20px', fontSize: '1rem', width: '150px' }} onClick={() => setOpenDownload(false)}>ปิด</Button>
                <Button variant='outlined' disabled={loadingDownloadDoi} sx={{ padding: '8px 20px', fontSize: '1rem', width: '200px' }} startIcon={loadingDownloadDoi ? <CircularProgress size={'24px'} color="inherit" /> : <FontAwesomeIcon icon={faPrint} />} onClick={() => downloadFileDoi()}>
                    พิมพ์ DOI
                </Button>
                <Button variant='outlined' disabled={loadingDownload} sx={{ padding: '8px 20px', fontSize: '1rem', width: '200px' }} startIcon={loadingDownload ? <CircularProgress size={'24px'} color="inherit" /> : <FontAwesomeIcon icon={faPrint} />} onClick={() => downloadFile()}>
                    พิมพ์ ใบสร็จ
                </Button>
                <Button variant='contained' sx={{ padding: '8px 20px', fontSize: '1rem', width: '150px' }} onClick={() => {
                    setOpenDownload(false)
                    window.location.reload()
                }}>
                    เพิ่มรายการใหม่
                </Button>
            </DialogActions>
        </Dialog>
    )
}
